import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { OrderSetupVerticalSelectWidget } from "Settings/Components/OrderSetupVerticalSelectWidget";
import { PageContainer } from "Shared/Components/Container";
import { useParams } from "react-router";

const orderSetupResource = Resources.base.orderSetup.shared;

export const VerticalSelectPage = () => {
	const { t } = useResource();
	const { marketId, verticalId } = useParams();
	const paramsMarketId = marketId ? Number(marketId) : undefined;
	const paramsVerticalId = verticalId ? Number(verticalId) : undefined;

	return (
		<PageContainer
			title={t(orderSetupResource.indexPageTitle)}
			description={t(orderSetupResource.indexPageDescription)}
		>
			<OrderSetupVerticalSelectWidget
				selectedMarketId={paramsMarketId}
				selectedVerticalId={paramsVerticalId}
			/>
		</PageContainer>
	);
};
